import { useEffect, useMemo, useState } from 'react';
import { UserType } from '../types/user.type';
import UserRepo from '../utils/repository/userRepo';
import hash from 'object-hash';

type FiltersType = {
    includeDisabled: boolean;
    userRoles: string[];
};

function useUsers(filters: Partial<FiltersType> = {}) {
    const [users, setUsers] = useState<UserType[]>([]);
    const [loading, setLoading] = useState(true);

    const memoizedFilters = useMemo(() => filters, [hash(filters)]);

    useEffect(() => {
        UserRepo.list(memoizedFilters, (users: UserType[]) => {
            setUsers(users);
            setLoading(false);
        });
    }, [memoizedFilters]);

    return { users, loading };
}

export default useUsers;
